const riot = require('riot');

riot.tag2('page-children-works', '<div class="bg-cream s-full"> <div class="sticky t0 z100" data-is="module-header" title="{t(&quot;works.title&quot;)}" close="{true}"> <yield to="right"> <div onclick="{parent.done}">{t(⁗header.done⁗)}</div> </yield> </div> <div class="bg-cream px16 py24"> <div class="w-full container"> <div class="mb30"> <div class="mb36 mb0-last"> <div class="fs18 mb12 fw6">{t(⁗works.for_guardians_label⁗)}</div> <div class="lh15 fw4 fs15 mb16 mb0-last" each="{description in getDescriptions()}">{description}</div> </div> </div> <div class="mb20" data-is="atom-action-button" text="{t(&quot;works.create_new&quot;)}" onclick="{goEditPage}"></div> <div class="mb20 mb0-last bg-white border border-primary-light bw4 px20 pt20 pb16" each="{work in works}"> <div class="f flex-between mb20"> <div class="fs16 letter-spacing-0 fw6 word-break-all"> <div class="mb4">{work.title}</div> <div class="f"> <div>{work.reward}{app.utils.getCurrencyText(currency, (work.reward !== 1))}</div> <div class="mx8">/</div> <div>{t(⁗works.once⁗)}</div> </div> </div><img class="block flex-fixed s50 object-fit-contain" riot-src="{work.icon_url.normal}"> </div> <div class="f flex-between text-white fs13 fw6 letter-spacing-0"> <div class="mr16 w-full py14 bg-primary-light rounded-4 f fh cursor-pointer" onclick="{goEditPage}">{t(⁗works.edit⁗)}</div> <div class="w-full py14 bg-danger rounded-4 f fh cursor-pointer" onclick="{confirmDelete}">{t(⁗works.delete⁗)}</div> </div> </div> </div> </div> </div>', '', '', function(opts) {
    this.preload = async({req, res}) => {
      var me_res = app.api.request({
        method: 'get',
        url: '/web/me',
      });

      var child_res = app.api.request({
        method: 'get',
        url: `/web/children/${req.params.id}`,
      });

      var works_res = app.api.request({
        method: 'get',
        url: `/web/children/${req.params.id}/works`,
      });

      var scroll_bottom = req.query.added;

      var promises = [
        me_res,
        child_res,
        works_res,
      ];

      var items = await Promise.all(promises);

      return {
        currency: items[0].data.family.currency,
        child: items[1].data.child,
        works: items[2].data.works,
        scroll_bottom,
      }
    };

    this.on('show', () => {
      if (this.scroll_bottom) {
        $('html, body').animate({
          scrollTop: $(document).height()
        });
      }
    });

    this.getDescriptions = () => {
      return [
        t("works.for_guardians_description_1"),
        t("works.for_guardians_description_2"),
      ];
    };

    this.done = () => {
      spat.router.push('/');
    };

    this.goEditPage = (e) => {

      if (e.item && e.item.work.id) {
        spat.router.push(`/children/${this.child.id}/works/${e.item.work.id}`);
      } else {
        spat.router.push(`/children/${this.child.id}/works/new`);
      }
    };

    this.confirmDelete = async(e) => {
      var message = t("message.confirm_delete", {name: e.item.work.title})
      var result = await spat.modal.confirm(message);
      if (!result) return ;
      var res = await app.api.request({
        method: 'delete',
        url: `/web/children/${this.child.id}/works/${e.item.work.id}`,
      });

      spat.router.push(`/children/${this.child.id}/works`);
    };
});